// SharedCubicMeterCalculator.js
import React, { useState } from 'react';
const CubicMeterCalculator = () => {
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [cubicMeter, setCubicMeter] = useState('');
    const [explanation, setExplanation] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('Harap masukkan dimensi dengan benar');
            setCubicMeter('');
            setExplanation('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue)) {
            setError('Harap masukkan dimensi kubus yang valid');
            setCubicMeter('');
            setExplanation('');
            return;
        }
        const volume = lengthValue * widthValue * heightValue;
        setCubicMeter(volume.toFixed(2));
        setExplanation(
            `Volume kubus (meter kubik) = panjang × lebar × tinggi = ${lengthValue} m × ${widthValue} m × ${heightValue} m = ${volume.toFixed(2)} m³`
        );
        setError('');
    };
    return (
        <div >
            <div>
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label htmlFor='height' className="form-label ms-2" >Panjang</label>
                    </b>
                    <input
                        type="number"
                        placeholder="30"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">m</span>
                    </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                <b>
                        <label className="form-label ms-2">Lebar</label>
                    </b>
                    <input
                        type="number"
                        placeholder="20"
                        value={width}
                        onChange={(e) => setWidth(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">m</span>
                    </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                <b>
                        <label className="form-label ms-2">Tinggi</label>
                    </b>
                    <input
                        type="number"
                        placeholder="14"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">m</span>
                    </div>
                </div>
                <br />
                <button
                    className="btn btn-success"
                    style={{ fontSize: '20px' }}
                    onClick={handleCalculate}
                >
                    Hitung Meter Kubik
                </button>
            </div>
            <br />
            <div>
                {error !== '' ? (
                    <p className='p-3 mb-2 bg-warning text-white'>Kesalahan: {error}</p>
                ) : (
                    <>
                        {cubicMeter !== '' && (
                            <>
                                <p className='p-3 mb-2 bg-success text-white'>
                                    Volume Kubus (Meter Kubik): {cubicMeter} m³
                                </p>
                                {explanation !== '' && (
                                    <p className='p-3 mb-2 bg-info text-black'>
                                        Langkah-langkah penyelesaian: <br />{explanation}
                                    </p>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default CubicMeterCalculator;